import React, { useState, useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  MechineryList,
  CreateMechinery,
  EditMechinery,
  DetailMachinery,
} from '../views/MECH';
import { HomeNavbar } from '../components/Navbars';
import { MainFooter } from '../components/Footers';
import { MainSidebar } from '../components/Sidebar';
import * as actions from '../redux/actions';
import { Loading } from '../components/Loading';
import { NotFound } from '../components/Error';
import accessRight from '../utils/functions/accessRight';

export function MECH() {
  const module = 'MECH';
  const prefix = '/mech';
  const name = 'จัดการข้อมูลเครื่องจักร';
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const me = useSelector((state) => state.me);
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => {
    setMobileNavOpen(true);
  };
  const handleOnMobileNavClose = () => {
    setMobileNavOpen(false);
  };

  useEffect(() => {
    dispatch(actions.meGet());
    dispatch(actions.informationAll());

    return () => {};
  }, []);

  if (!me.userData) {
    return <Loading />;
  }
  if (accessRight(me, module)) {
    return (
      <div className="min-h-screen">
        <MainSidebar
          onMobileClose={handleOnMobileNavClose}
          openMobile={isMobileNavOpen}
          me={me}
        />
        <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />
        <div className="lg:ml-64  min-h-screen  pt-16 px-8 ">
          <div className="py-4">
            <Switch>
              <Redirect exact from={`${prefix}`} to={`${prefix}/mech`} />
              <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
              <Route exact path={`${prefix}/mech`}>
                <MechineryList title={'รายการเครื่องจักร'} subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/mech/create`}>
                <CreateMechinery title={'เพิ่มเครื่องจักร'} subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/mech/edit/:id`}>
                <EditMechinery title={'แก้ไขเครื่องจักร'} subtitle={name} />
              </Route>
              <Route exact path={`${prefix}/mech/detail/:id`}>
                <DetailMachinery title={'รายละเอียด'} subtitle={name} />
              </Route>

              {/* {accessRight(me, module, 1) && (
                <Switch>
                  <Route exact path={`${prefix}/customer-types`}>
                    <CustomerTypes title={'ประเภทลูกค้า'} subtitle={name} />
                  </Route>
                  <Route exact path={`${prefix}/customer-type/edit/:id`}>
                    <EditCustomerType
                      title={'แก้ไขประเภทลูกค้า'}
                      subtitle={name}
                    />
                  </Route>
                  <Route path="*">
                    <NotFound />
                  </Route>
                </Switch>
              )} */}
              <Route path="*">
                <NotFound />
              </Route>
            </Switch>
          </div>
        </div>
        <div className="lg:ml-64">
          <MainFooter />
        </div>
      </div>
    );
  }
  return <></>;
}

export default MECH;
